import React from 'react';
import Message from './Message';
import '../styles/MessageGroup.css';

function ChannelBadge({ icon, displayName, onClick }) {
  const isImageIcon = icon && /\.(png|jpe?g|webp|ico)$/i.test(icon);
  return (
    <div className="channel-badge" onClick={onClick}>
      <span className="channel-badge-icon">
        {isImageIcon
          ? <img src={`/channel-icons/${icon}`} alt="" className="channel-badge-img" />
          : (icon || '📢')}
      </span>
      <span className="channel-badge-name">{displayName}</span>
      <span className="channel-badge-arrow">→</span>
    </div>
  );
}

function MessageGroup({ group, currentUser, onImageLoad, onReply, onDelete, firstUnreadMessageId, isAllMode, onNavigateToChannel }) {
  const { messages, isOwn, displayName, avatar } = group;

  const handleChannelClick = () => {
    if (isAllMode && onNavigateToChannel && messages[0]?.channelId) {
      onNavigateToChannel(messages[0].channelId, messages[0].id);
    }
  };

  const makeMessageNavigate = (message) => {
    if (!isAllMode || !onNavigateToChannel || !message.channelId) return null;
    return () => onNavigateToChannel(message.channelId, message.id);
  };

  return (
    <div className={`message-group ${isOwn ? 'own' : 'other'} ${isAllMode ? 'all-mode' : ''}`}>
      {!isOwn && (
        <div className="group-avatar">
          <div className="avatar-circle">
            {avatar
              ? <img src={avatar} alt={displayName} className="avatar-img" />
              : [...displayName][0].toUpperCase()
            }
          </div>
        </div>
      )}

      <div className="group-content">
        {isAllMode && messages[0]?.channelDisplayName && (
          <ChannelBadge
            icon={messages[0].channelIcon}
            displayName={messages[0].channelDisplayName}
            onClick={handleChannelClick}
          />
        )}

        {!isOwn && (
          <div className="group-author">{displayName}</div>
        )}

        <div className="group-messages">
          {messages.map((message, index) => (
            <Message
              key={message.id}
              message={message}
              isOwn={isOwn}
              isFirst={index === 0}
              isLast={index === messages.length - 1}
              showAvatar={false}
              inGroup={true}
              onImageLoad={onImageLoad}
              currentUser={currentUser}
              onReply={isAllMode ? null : onReply}
              onDelete={isAllMode ? null : onDelete}
              firstUnreadMessageId={firstUnreadMessageId}
              onAllModeNavigate={makeMessageNavigate(message)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default MessageGroup;
